import Rebase from "re-base";
import firebase from "firebase/app";
import 'firebase/database'
import 'firebase/auth'
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyD6FHkAnFuuoogKgMttnu6OUrHNbe47VGo",
  authDomain: "burgers-1bd08.firebaseapp.com",
  projectId: "burgers-1bd08",
});
const base = Rebase.createClass(firebaseApp.database());

export { firebaseApp };
export default base;
